import React from 'react';
import LoginPage from '../../../components/login/login/LoginPage.jsx';
import {createRoot} from "react-dom/client";
import JshModule from "@core/scripts/helper/jsh-module";

const {moduleScope, config: {loginPageConfig}} = JshModule('checkout/login/login-page');

createRoot(moduleScope).render(
    <LoginPage
        texts={loginPageConfig.texts}
        email={loginPageConfig.email}
        loginFormAction={loginPageConfig.loginFormAction}
        siteKeyLogin={loginPageConfig.siteKeyLogin}
        siteKeyForgotPassword={loginPageConfig.siteKeyForgotPassword}
        isCaptchaEnabled={loginPageConfig.isCaptchaEnabled}
        isCaptchaV2Enabled={loginPageConfig.isCaptchaV2Enabled}
        captchaLang={loginPageConfig.captchaLang}
    />
);
